/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum PatientVaccinatedStatus {
    YES_ACCORDING_TO_SCHEDULE = 'yesAccordingToSchedule',
    YES_WITH_VIOLATIONS = 'yesWithViolations',
    NO = 'no',
    UNKNOWN = 'unknown',
}
